@use "../../../../../../common/scss/mixins";
@use "../../../../../../common/scss/font";
@use "../../../../../../common/scss/colors";

@mixin order--compact {
  padding: 1rem;
}

@mixin order__display--mobile {
  display: inline-flex;
}

@mixin order__display--desktop {
  display: none;
}

@mixin order__content {
  flex-direction: column;
}

@mixin order__header {
  font-weight: font.$weight--regular;
  font-size: font.$size--medium;
  line-height: 1.125rem;
  color: colors.$dark_grey_on_white;
  display: flex;
  justify-content: space-between;
  padding-bottom: 0.5rem;
}

@mixin order__abo-name {
  padding-bottom: 0.75rem;
}

@mixin order__order-date {
  flex-basis: auto;
}

@mixin order__order-number {
  text-align: right;
  flex-basis: auto;
}

@mixin order__order-footer {
  flex-direction: row-reverse;
  font-weight: font.$weight--regular;
  font-size: font.$size--medium;
  line-height: 1.125rem;
  text-align: right;
}

%order {
  display: flex;
  border: 0.0625rem solid colors.$light_gray;
  transition: border 100ms ease-out;
  animation-timing-function: ease-out;
  border-radius: 0.75rem;
  padding: 1rem 1.5rem;
  margin-bottom: 0.5rem;
  justify-content: space-between;
  align-items: center;
}

.order {
  @extend %order;

  &:hover {
    border: 0.0625rem solid colors.$blue;
  }

  @include mixins.md_m {
    @include order--compact;
  }

  &__display {
    &--mobile {
      display: none;

      @include mixins.md_m {
        @include order__display--mobile;
      }
    }

    &--desktop {
      display: inline-flex;

      @include mixins.md_m {
        @include order__display--desktop;
      }
    }
  }

  &__content {
    display: flex;
    justify-content: space-between;
    width: 100%;
    font-family: font.$family--primary;
    font-weight: font.$weight--medium;
    font-size: font.$size--standard;
    line-height: 1.5rem;
    color: colors.$amway_black;

    @include mixins.md_m {
      @include order__content;
    }
  }

  &__header {
    @include mixins.md_m {
      @include order__header;
    }
  }

  %flex-grow {
    flex-basis: 15%;
    flex-grow: 1;
  }

  &__abo-name {
    flex-basis: 25%;
    flex-grow: 1;

    @include mixins.md_m {
      @include order__abo-name;
    }
  }

  &__order-date {
    @extend %flex-grow;

    @include mixins.md_m {
      @include order__order-date;
    }
  }

  &__order-number,
  &__pv,
  &__order-type,
  &__bv {
    @extend %flex-grow;

    &__right {
      flex-flow: row-reverse;
      padding-right: 1.375rem;
    }

    @include mixins.md_m {
      @include order__order-number;
    }
  }

  &__footer {
    display: flex;
    justify-content: space-between;
    flex-basis: 45%;

    @include mixins.md_m {
      @include order__order-footer;
    }
  }

  &__arrow-icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &--compact {
    @include order--compact;

    .order {
      &__display {
        &--mobile {
          @include order__display--mobile;
        }

        &--desktop {
          @include order__display--desktop;
        }
      }

      &__content {
        @include order__content;
      }

      &__header {
        @include order__header;
      }

      &__abo-name {
        @include order__abo-name;
      }

      &__order-date {
        @include order__order-date;
      }

      &__order-number,
      &__pv,
      &__order-type,
      &__bv {
        @include order__order-number;
      }

      &__footer {
        @include order__order-footer;
      }
    }
  }
}
